import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

import SuccessHandler from '../SuccessHandler'

/* private BrandConfigurationShopifySettingsTypes */
import {
  Settings,
  _BrandConfigurationShopifySettings
} from '../namespace-helper'

import _ from 'lodash'

const selectedBrandConfigurationShopifySettingTemplate = {
  id: null,
  name: 'New Brand Shopify Setting',
  base_url: null,
  access_token: null,
  api_version: null
}

export default {
  namespaced: true,
  state: {
    brandConfigurationShopifySettings: [],
    allBrandConfigurationShopifySettings: [],
    selectedBrandConfigurationShopifySetting: _.cloneDeep(selectedBrandConfigurationShopifySettingTemplate),
    openDialog: false
  },
  mutations: {
    [_BrandConfigurationShopifySettings.mutations.setBrandConfigurationShopifySettings] (state, payload) {
      state.brandConfigurationShopifySettings = payload
    },
    [_BrandConfigurationShopifySettings.mutations.setAllBrandConfigurationShopifySettings] (state, payload) {
      state.allBrandConfigurationShopifySettings = payload
    },
    [_BrandConfigurationShopifySettings.mutations.setSelectedBrandConfigurationShopifySettings] (state, payload) {
      if (payload !== null) {
        state.selectedBrandConfigurationShopifySetting = payload
      } else {
        state.selectedBrandConfigurationShopifySetting = _.cloneDeep(selectedBrandConfigurationShopifySettingTemplate)
      }
    },
    [_BrandConfigurationShopifySettings.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    },
    [_BrandConfigurationShopifySettings.mutations.addNewItem] (state, payload) {
      if (state.brandConfigurationShopifySettings === null) {
        state.brandConfigurationShopifySettings = []
      }
      state.brandConfigurationShopifySettings.push(payload)
    },
    [_BrandConfigurationShopifySettings.mutations.removeItem] (state, payload) {
      state.brandConfigurationShopifySettings.splice(payload, 1)
    }
  },
  actions: {
    [_BrandConfigurationShopifySettings.actions.saveBrandConfigurationShopifySettings] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      payload.forEach(function (v, i, o) {
        const data = JSON.stringify(v)

        if (v.id === null) {
          var url = API_URL + '/api/v1/brandConfigurationShopifySettings'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/brandConfigurationShopifySettings/' + v.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_BrandConfigurationShopifySettings.actions.loadBrandConfigurationShopifySettings] (context, payload) {
      console.log('loadBrandConfigurationShopifySettings: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/brandConfigurationShopifySettings'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationShopifySettings.mutations.setBrandConfigurationShopifySettings, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationShopifySettings.actions.loadAllBrandConfigurationShopifySettings] (context, payload) {
      var url = API_URL + '/api/v1/brandConfigurationShopifySettings'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationShopifySettings.mutations.setAllBrandConfigurationShopifySettings, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationShopifySettings.actions.removeItem] (context, payload) {
      const tempItems = context.getters.brandConfigurationShopifySettings
      const id = tempItems[payload].id

      if (id === null) {
        context.commit(_BrandConfigurationShopifySettings.mutations.removeItem, payload)
        return
      }

      var url = API_URL + '/api/v1/brandConfigurationShopifySettings/' + id

      console.log('remove item: ' + id)

      store.commit(Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationShopifySettings.mutations.removeItem, payload)
        SuccessHandler.handleApiSuccess(store, r.data.message)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationShopifySettings.actions.openCloseDialog] ({ commit }) {
      commit(_BrandConfigurationShopifySettings.mutations.setOpenCloseDialogState)
    },
    [_BrandConfigurationShopifySettings.actions.setSelectedBrandConfigurationShopifySettings] ({ commit }, payload) {
      commit(_BrandConfigurationShopifySettings.mutations.setSelectedBrandConfigurationShopifySettings, payload)
    },
    [_BrandConfigurationShopifySettings.actions.addNewItem] ({ commit }, payload) {
      commit(_BrandConfigurationShopifySettings.mutations.addNewItem, payload)
    },
    [_BrandConfigurationShopifySettings.actions.resetState] ({ commit }, payload) {
      commit(_BrandConfigurationShopifySettings.mutations.setBrandConfigurationShopifySettings, [])
      commit(_BrandConfigurationShopifySettings.mutations.setAllBrandConfigurationShopifySettings, [])
      commit(_BrandConfigurationShopifySettings.mutations.setSelectedBrandConfigurationShopifySettings, null)
    }
  },
  getters: {
    [_BrandConfigurationShopifySettings.getters.brandConfigurationShopifySettings] (state) {
      return state.brandConfigurationShopifySettings
    },
    [_BrandConfigurationShopifySettings.getters.getAllBrandConfigurationShopifySettings] (state) {
      return state.allBrandConfigurationShopifySettings
    },
    [_BrandConfigurationShopifySettings.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_BrandConfigurationShopifySettings.getters.getSelectedBrandConfigurationShopifySettings] (state) {
      return state.selectedBrandConfigurationShopifySetting
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/BrandConfiguration/brandConfigurationsShopifySettings.js